module.exports = __webpack_public_path__ + "img/kiosk-specifications-fr.b48d4131.png";